<template>
  <v-card class="pa-2 grey darken-3" style="min-width: 320px; max-width: 320px; margin-left: calc(50% - 160px)">
    <v-card-title class="py-0 px-2">
      <v-layout fill-height align-center wrap mb-1>
        <v-flex xs8 text-xs-left>
          <div class="white--text subheading font-weight-bold">
            {{ $language.registration["Credit Card"] }}
          </div>
        </v-flex>
        <v-flex xs4 pl-2>
          <v-img width="80px" height="40px" :src="`${ require('@/assets/stripe-logo-blue.svg') }`"></v-img>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text class="py-4 px-2">
      <div id="card-element">

      </div>
    </v-card-text>
    <v-card-actions class="py-2 px-2">
      <v-spacer></v-spacer>

          <v-btn depressed class="font-weight-bold text-none" color="primary" @click="generateTokenCard">
            {{ $language.registration["Add Card"] }}
          </v-btn>

    </v-card-actions>
    <v-snackbar v-model="snack" :timeout="1500">
      {{message}}
    </v-snackbar>
  </v-card>
  <!-- <v-flex xs12>
    <v-card>
      <v-card-title primary-title>
        Bank Account (requires further verification)
      </v-card-title>
      <v-card-text>
        <v-text-field label="Routing #" v-model="stripeBank.routing_number"></v-text-field>
        <v-text-field label="account_number #" v-model="stripeBank.account_number"></v-text-field>
        <v-text-field label="account_holder_name " v-model="stripeBank.account_holder_name"></v-text-field>
        <v-text-field label="account_holder_type" v-model="stripeBank.account_holder_type"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="generateToken">Bank</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex> -->

</template>

<script>
import {
  mapState
} from 'vuex'
const fb = require('@/services/firebaseConfig.js')

export default {

  mounted () {
    this.includeStripe('js.stripe.com/v3/', function () {
      this.configureStripe()
    }.bind(this))
  },
  props: ['isCust'],

  data () {
    return {
      stripeBank: {
        country: 'US',
        currency: 'USD',
        routing_number: '110000000',
        account_number: '000123456789',
        account_holder_name: 'Head',
        account_holder_type: 'individual'
      },
      token: null,
      message: null,
      snack: false,
      // stripeAPIToken: 'pk_test_AHNfwDx9PtSryN9BG2jIvxcO',
      stripeAPIToken: 'pk_live_X76NZlh5mkzn7rJcRlc5ZRgY',

      stripe: '',
      elements: '',
      card: ''
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories'])

  },
  methods: {
    includeStripe (URL, callback) {
      let documentTag = document
      let tag = 'script'
      let object = documentTag.createElement(tag)
      let scriptTag = documentTag.getElementsByTagName(tag)[0]
      object.src = '//' + URL
      if (callback) {
        object.addEventListener('load', function (e) {
          callback(null, e)
        }, false)
      }
      scriptTag.parentNode.insertBefore(object, scriptTag)
    },
    configureStripe () {
      /* eslint-disable */
      this.stripe = Stripe(this.stripeAPIToken)
      /* eslint-enable */

      this.elements = this.stripe.elements()
      var style = {
        base: {
          // Add your base input styles here. For example:
          fontSize: '16px',
          color: '#FFFFFF'
        }
      }
      this.card = this.elements.create('card', {
        style: style
      })

      this.card.mount('#card-element')
    },
    // generateToken (type, data) {
    //   console.log(type, data)
    //   stripe.createToken('bank_account', this.stripeBank).then((response) => {
    //     this.token = response.token
    //     if (response.token) {
    //       fb.database.ref(`user/${this.currentUser.uid}/profile/stripeCustomerAccount/token`).set(this.token)
    //       fb.database.ref(`user/${this.currentUser.uid}/profile/stripeAuthStatus`).set('authorized')
    //       this.message = this.$language.registration['Payment method saved!']
    //       this.$emit('open', true)
    //       this.snack = true
    //     } else {
    //       this.message = response.error.message
    //       this.snack = true
    //     }
    //   }).catch((error) => {
    //     console.log('error', error)
    //   })
    // },
    generateTokenCard () {
      this.stripe.createToken(this.card).then((response) => {
        this.token = response.token
        if (response.token) {
          if (this.isCust) {
            fb.database.ref(`user/${this.currentUser.uid}/profile/stripeCustomerAccount/addSource/token`).set(this.token)
            fb.database.ref(`user/${this.currentUser.uid}/profile/stripeCustomerAccount/processing`).set(true)
          } else {
            fb.database.ref(`user/${this.currentUser.uid}/profile/stripeCustomerAccount/processing`).set(true)
            fb.database.ref(`user/${this.currentUser.uid}/profile/stripeCustomerAccount/token`).set(this.token)
            fb.database.ref(`user/${this.currentUser.uid}/profile/stripeAuthStatus`).set('authorized')
          }

          this.message = this.$language.registration['Payment method saved!']
          this.snack = true
          this.$emit('open', true)
        } else {
          this.message = response.error.message
          this.snack = true
        }
      }).catch((error) => {
        console.log('error', error)
        this.message = this.$language.registration['Error saving payment method']
        this.snack = true
      })
      // }
    }
  }
}
</script>
<style>
.card-element {
  box-sizing: border-box;
  height: 40px;
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 15px;
  background-color: white;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.card-element--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.card-element--invalid {
  border-color: #fa755a;
}

.card-element--webkit-autofill {
  background-color: #fefde5 !important;
}
</style>
